import { render, staticRenderFns } from "./customlistIndex.vue?vue&type=template&id=0cf3f81f&scoped=true"
import script from "./customlistIndex.vue?vue&type=script&lang=js"
export * from "./customlistIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3f81f",
  null
  
)

export default component.exports